/**
 * Cierre de sesión de la app: una sola forma, que usan el menú del usuario y
 * los avisos que piden volver a entrar (p. ej. el de MFA de la plataforma).
 */

import { useCallback } from 'react'
import { useAccount, useMsal } from '@azure/msal-react'

import { useNotificationStreamStore } from '../stores/notificationStreamStore'

export function useSignOut(): () => void {
  const { instance, accounts } = useMsal()
  const account = useAccount(accounts[0])
  const disconnectStream = useNotificationStreamStore((s) => s.disconnect)

  return useCallback(() => {
    // Doc 21 Fase 7.h — cerrar el stream antes del logout: si no, sigue
    // abierto con el token viejo (y reintentando si se corta) hasta que el
    // navegador sale de la página.
    disconnectStream()
    void instance.logoutRedirect({ account: account ?? null })
  }, [instance, account, disconnectStream])
}
